import {ChangeEvent, FC, useRef} from 'react'
import {TextAreaInterface} from './types'

const TextArea: FC<TextAreaInterface> = ({formik, name, label, value = undefined, flex, cols, rows, setLetterCount, maxLength}) => {

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const fieldProps = formik.getFieldProps(name)

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (setLetterCount) setLetterCount(event.target.value.length);
    fieldProps.onChange(event);
  };

  return (
    <div className={`row mb-2 mb-lg-6 d-flex flex-${flex}`}>

      <label htmlFor={name}
             className={`${flex === 'column' ? 'col-12' : 'col-3'} d-flex align-items-center col-form-label fw-bold fs-7`}>{label}</label>

      <div className={`${flex === 'column' ? 'col-12' : 'col-9'} fv-row`}>
        <textarea className="form-control form-control-sm form-control-solid mb-0"
                  cols={cols}
                  rows={rows}
                  placeholder={label}
                  id={name}
                  {...fieldProps}
                  value={value ?? fieldProps.value}
                  onChange={handleChange}
                  readOnly={!!value}
                  ref={textAreaRef}
                  maxLength={maxLength ? maxLength : 1000}
        />
        {formik.touched[name] && formik.errors[name] && (
          <div
            className="fv-plugins-message-container my-1 user-select-none">
            <div className="fv-help-block">
              <span role="alert" className="text-danger p-2">{formik.errors[name]}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export {TextArea}